// extracted by mini-css-extract-plugin
export default {"wrapperClass":"KbEthUECGr25JBYlfj7L"};